import CustomerManagement from "../CRM/CustomerManagement";
import VoucherAdministration from "../CRM/VoucherAdministration";
import PromotionManagement from "../CRM/PromotionManagement";
import CustomerLookupLinks from "../CRM/CustomerLookupLinks";
import CustomerVouchers from "../CRM/CustomerVouchers";
import React, { useState, useEffect } from "react";
import {
  FiHome,
  FiPackage,
  FiClock,
  FiGlobe,
  FiCreditCard,
  FiBarChart2,
  FiDollarSign,
  FiUser,
  FiTrendingUp,
  FiTrendingDown,
  FiCheckCircle,
  FiUsers,
  FiRefreshCw,
  FiActivity,
  FiBox,
  FiChevronLeft,
  FiChevronRight,
  FiClipboard,
  FiPlus,
  FiTruck,
  FiPieChart,
  FiShoppingBag,
} from "react-icons/fi";
import { FaBoxes, FaWeight } from "react-icons/fa";
import "./Admin.css";
import TaxInvoiceLegacyPage from "./TaxInvoiceLegacyPage";

// Import admin components
import Dashboard from "./dashboard";
import QuanLySanPham from "./QuanLySanPham";
import ManageShift from "./ManageShift";
import UpdateIP from "./UpdateIP";
import UpdateQR from "./UpdateQR";
import QuanLyKho from "./QuanLyKho";
import PosInventoryPage from "./inventory/khohang";
import UpdateRounding from "./UpdateRounding";
import DinhMucDinhLuong from "../DinhMucDinhLuong";
import QuanLyDinhMuc from "../QuanLyDinhMuc";
import ManageProduct from "../ManageProduct";
import KiemKe from "../KiemKe";
import NhapHangAdmin from "./NhapHangAdmin";
import DieuChuyen from "../../components/DieuChuyen/DieuChuyen";
import ListDieuChuyen from "../../components/DieuChuyen/ListDieuChuyen";
import ConfirmDieuChuyen from "../../components/DieuChuyen/ConfirmDieuChuyen";
import GioChamCong from "../../components/ChamCong/GioChamCong";
import ThongKeBanhTrungThu from "./ThongKeBanhTrungThu";
import DSTrungThu from "../../components/DoanhSoTrungThu/DSTrungThu";
import QuyenSD from "./QuyenSD";
import ManageBill from "../../components/Manage-bill/ManageBill";
import ScheduleUpdate from "./ScheduleUpdate";
import DashboardBkemCustomByMockData from "../../components/BanhKemDashboard/DashboardBkemCustomByMockData";
import StoreInfo from "./StoreInfo";

const Admin = ({ initialComponent = "dashboard" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState(initialComponent);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState(null); // Add user role state
  const [userPermissions, setUserPermissions] = useState([]); // Add user permissions state
  const [chamCongToken, setChamCongToken] = useState(""); // Move this hook to the top

  //base64 to Uint8Array
  const base64ToUint8Array = (base64) => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  };

  function base64UrlEncode(uint8Array) {
    return btoa(String.fromCharCode(...uint8Array))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  const encryptMaPB = async (maPB) => {
    try {
      const keyBase64 = "Y9uXcI3uV0f6hHLOsF5FHzT2F9t3P2tQl05JpAdFojw=";
      const keyBytes = base64ToUint8Array(keyBase64);

      const iv = crypto.getRandomValues(new Uint8Array(12));
      const data = new TextEncoder().encode(maPB);

      const cryptoKey = await crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-GCM" },
        false,
        ["encrypt"]
      );

      const encrypted = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        cryptoKey,
        data
      );

      const encryptedArray = new Uint8Array(encrypted);

      // AES-GCM: tag nằm ở cuối (16 bytes)
      const tagLength = 16;
      const ciphertext = encryptedArray.slice(0, -tagLength);
      const tag = encryptedArray.slice(-tagLength);

      // IV + TAG + CIPHERTEXT
      const combined = new Uint8Array(
        iv.length + tag.length + ciphertext.length
      );
      combined.set(iv, 0);
      combined.set(tag, iv.length);
      combined.set(ciphertext, iv.length + tag.length);

      // Base64URL (KHÔNG có + / =)
      return base64UrlEncode(combined);
    } catch (error) {
      console.error("Encryption error:", error);
      return base64UrlEncode(
        new TextEncoder().encode(`maPB=${maPB}`)
      );
    }
  };

  // Get maNV and maPB from localStorage for Cham Cong URL
  const maNV = localStorage.getItem("MaNV") || "QL75PDL";
  const maPB = localStorage.getItem("MaPB") || "119";

  // Check admin/bakery authentication
  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = localStorage.getItem("token");
        const isAdmin = localStorage.getItem("isAdmin");
        const isBakery = localStorage.getItem("isBakery");
        const isHCM = localStorage.getItem("HCM_ADMIN")

        if (!token || (isAdmin !== "true" && isBakery !== "true" && isHCM !== "true")) {
          // Redirect to login if not authenticated or not admin/bakery
          window.location.href = "/login";
          return;
        }

        // Set initial user role (temporary, will be updated based on permissions)
        if (isAdmin === "true") {
          setUserRole("admin");
        } else if (isBakery === "true") {
          setUserRole("bakery");
        } else if (isHCM === "true") {
          setUserRole("hcm")
        }

        // Verify token is still valid
        if (token) {
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
        window.location.href = "/login";
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Fetch user permissions after authentication
  useEffect(() => {
    if (isAuthenticated) {
      const maPB = localStorage.getItem("MaPB");
      const maNV = localStorage.getItem("MaNV");
      if (maPB && maNV) {
        fetch(`https://doticom.vn:3000/api/user-permissions?MaPB=${maPB}`)
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              const userPerm = data.data.find((item) => item.MaNV === maNV);
              if (userPerm) {
                setUserPermissions(userPerm.permissions);
                // Set userRole based on permissions
                if (userPerm.permissions.includes("admin.access")) {
                  setUserRole("admin");
                } else {
                  setUserRole("bakery");
                }
              } else {
                // Default to bakery if no permissions found
                setUserRole("bakery");
                setUserPermissions([]);
              }
            }
          })
          .catch((err) => {
            console.error("Failed to fetch permissions:", err);
            // Default to bakery on error
            setUserRole("bakery");
            setUserPermissions([]);
          });
      }
    }
  }, [isAuthenticated]);

  // Create encrypted token for chamCongParams
  useEffect(() => {
    if (maPB) {
      encryptMaPB(maPB).then((token) => {
        setChamCongToken(token);
      });
    }
  }, [maPB]);

  // Show loading screen while checking authentication
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <FiRefreshCw
            size={48}
            style={{ animation: "spin 1s linear infinite" }}
          />
          <p style={{ marginTop: "16px", color: "#6c757d" }}>
            Checking authentication...
          </p>
        </div>
      </div>
    );
  }

  // Don't render admin content if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  const allFeatures = [
    {
      id: "dashboard",
      title: "Dashboard",
      description: "Xem tổng quan hệ thống",
      icon: <FiBarChart2 />,
      category: "Analytics",
      component: Dashboard,
      requiredPermissions: ["dashboard.view", "system.access"],
    },
    {
      id: "thong-ke-banh-trung-thu",
      title: "Tồn kho bánh trung thu",
      description: "Thống kê tồn kho bánh trung thu theo cửa hàng",
      icon: <FiPieChart />,
      category: "Analytics",
      component: ThongKeBanhTrungThu,
      requiredPermissions: ["report.inventory.view", "report.view"],
    },
    {
      id: "dashboard-banh-kem",
      title: "Dashboard bánh kem",
      description: "Theo dõi KPI, tồn kho và xu hướng bán bánh kem",
      icon: <FiBarChart2 />,
      category: "Analytics",
      component: DashboardBkemCustomByMockData,
      requiredPermissions: ["cake.dashboard.view"],
    },
    {
      id: "ds-trung-thu",
      title: "Doanh số bánh trung thu",
      description: "Thống kê doanh số bán bánh trung thu chi tiết",
      icon: <FiBarChart2 />,
      category: "Analytics",
      component: DSTrungThu,
      requiredPermissions: ["report.sales.view", "report.view"],
    },
    {
      id: "nhap-hang-admin",
      title: "Tạo Phiếu Nhập Admin",
      description: "Tạo phiếu nhập với quyền admin - tự động duyệt",
      icon: <FiPlus />,
      category: "Inventory",
      component: NhapHangAdmin,
      requiredPermissions: ["inventory.import.create", "inventory.manage"],
    },
    {
      id: "dieu-chuyen",
      title: "Điều chuyển kho",
      description: "Điều chuyển sản phẩm giữa các cửa hàng",
      icon: <FiTruck />,
      category: "Inventory",
      component: DieuChuyen,
      requiredPermissions: ["inventory.transfer.create", "inventory.manage"],
    },
    {
      id: "manage-product",
      title: "Quản lý giá sản phẩm",
      description: "Quản lý giá sản phẩm",
      icon: <FiPackage />,
      category: "Inventory",
      component: QuanLySanPham,
      requiredPermissions: ["product.price.manage", "product.manage"],
    },
    {
      id: "schedule-price-update",
      title: "Lịch cập nhật giá",
      description: "Lên lịch tự động cập nhật giá sản phẩm",
      icon: <FiClock />,
      category: "Inventory",
      component: ScheduleUpdate,
      requiredPermissions: ["product.price.schedule", "product.price.manage"],
    },
    {
      id: "manage-product-new",
      title: "Manage Product (New)",
      description: "Quản lý sản phẩm (phiên bản mới)",
      icon: <FiPackage />,
      category: "Inventory",
      component: ManageProduct,
      requiredPermissions: ["product.manage", "product.create", "product.edit"],
    },
    {
      id: "manage-inventory",
      title: "Manage Inventory",
      description: "Quản lý kho hàng",
      icon: <FiBox />,
      category: "Inventory",
      component: QuanLyKho,
      requiredPermissions: ["inventory1.view", "inventory1.manage"],
    },
    {
      id: "pos-inventory",
      title: "Kho POS realtime",
      description: "Xem tồn POS realtime, ledger và báo cáo XNT",
      icon: <FiActivity />,
      category: "Inventory",
      component: PosInventoryPage,
      requiredPermissions: ["inventory.view", "inventory.manage"],
    },
    {
      id: "kiem-ke",
      title: "Kiểm kê tồn kho",
      description: "Kiểm tra và cập nhật số lượng tồn kho",
      icon: <FiClipboard />,
      category: "Inventory",
      component: KiemKe,
      requiredPermissions: ["inventory.audit.manage", "inventory.manage"],
    },
    {
      id: "manage-shift",
      title: "Manage Shift",
      description: "Quản lý ca làm nhân viên",
      icon: <FiClock />,
      category: "HR",
      component: ManageShift,
      requiredPermissions: ["hr.shift.manage", "user.manage"],
    },
    {
      id: "gio-cham-cong",
      title: "Giờ chấm công",
      description: "Tra cứu lịch sử chấm công của nhân viên",
      icon: <FiClock />,
      category: "HR",
      component: GioChamCong,
      requiredPermissions: ["hr.attendance.view", "user.manage"],
    },
    {
      id: "update-ip",
      title: "Update IP",
      description: "Cập nhật địa chỉ IP hệ thống",
      icon: <FiGlobe />,
      category: "System",
      component: UpdateIP,
      requiredPermissions: ["system.network.manage", "admin.access"],
    },
    {
      id: "update-qr-code",
      title: "QR Code",
      description: "Cập nhật mã QR thanh toán",
      icon: <FiCreditCard />,
      category: "Payment",
      component: UpdateQR,
      requiredPermissions: ["payment.qr.manage", "admin.access"],
    },
    {
      id: "update-rounding",
      title: "Update Rounding",
      description: "Cập nhật quy tắc làm tròn tiền",
      icon: <FiDollarSign />,
      category: "Payment",
      component: UpdateRounding,
      requiredPermissions: ["payment.rounding.manage", "admin.access"],
    },
    {
      id: "store-info",
      title: "Thông tin cửa hàng",
      description: "Cập nhật thông tin ngân hàng, liên hệ và địa chỉ cửa hàng",
      icon: <FiShoppingBag />,
      category: "System",
      component: StoreInfo,
      requiredPermissions: ["store.info.manage", "admin.access"],
    },
    {
      id: "dinh-muc-dinh-luong",
      title: "Định mức Định lượng",
      description: "Quản lý nguyên liệu và định lượng sản phẩm",
      icon: <FaBoxes />,
      category: "Production",
      component: DinhMucDinhLuong,
      requiredPermissions: ["production.materials.manage", "admin.access"],
    },
    {
      id: "quan-ly-dinh-muc",
      title: "Quản lý Định mức",
      description: "Quản lý định mức nguyên liệu cho sản phẩm",
      icon: <FaWeight />,
      category: "Production",
      component: QuanLyDinhMuc,
      requiredPermissions: ["production.quota.manage", "admin.access"],
    },
    {
      id: "list-dieu-chuyen",
      title: "Danh sách điều chuyển",
      description: "Xem danh sách phiếu điều chuyển kho",
      icon: <FiClipboard />,
      category: "Inventory",
      component: ListDieuChuyen,
      requiredPermissions: ["inventory.transfer.view", "inventory.manage"],
    },
    {
      id: "confirm-dieu-chuyen",
      title: "Xác nhận điều chuyển",
      description: "Xác nhận các phiếu điều chuyển kho",
      icon: <FiCheckCircle />,
      category: "Inventory",
      component: ConfirmDieuChuyen,
      requiredPermissions: ["inventory.transfer.approve", "inventory.manage"],
    },
    {
      id: "quan-ly-quyen",
      title: "Quản lý quyền",
      description: "Phân quyền cho nhân viên theo phòng ban",
      icon: <FiUser />,
      category: "System",
      component: QuyenSD,
      requiredPermissions: ["permission.manage"],
    },
    {
      id: "customer-management",
      title: "Quản trị khách hàng",
      description: "Hồ sơ, điểm và lịch sử thay đổi khách hàng",
      icon: <FiUsers />, category: "Sales", component: CustomerManagement,
      requiredPermissions: ["admin.access", "permission.manage"],
    },
    { id: "voucher-management", title: "Quản lý và phát hành Voucher", description: "Tạo chương trình, phát hành và xem lịch sử Voucher", icon: <FiUsers />, category: "Sales", component: VoucherAdministration, requiredPermissions: ["admin.access", "permission.manage"] },
    { id: "promotion-management", title: "Ưu đãi cửa hàng", description: "Cửa hàng áp dụng ưu đãi 9 và 13", icon: <FiUsers />, category: "Sales", component: PromotionManagement, requiredPermissions: ["admin.access", "permission.manage"] },
    { id: "customer-lookup-links", title: "Tạo link tra cứu Zalo", description: "Liên kết tra cứu điểm và Voucher có token mã hóa", icon: <FiUsers />, category: "Sales", component: CustomerLookupLinks, requiredPermissions: ["admin.access", "permission.manage"] },
    { id: "customer-vouchers-manage", title: "Kho Voucher khách hàng", description: "Tra cứu và thu hồi Voucher", icon: <FiUsers />, category: "Sales", component: () => <CustomerVouchers manage />, requiredPermissions: ["admin.access", "permission.manage"] },
    {
      id: "manage-bill",
      title: "Quản lý hóa đơn",
      description: "Quản lý và tra cứu hóa đơn bán hàng",
      icon: <FiClipboard />,
      category: "Sales",
      component: ManageBill,
      requiredPermissions: ["bill.view", "bill.manage", "sales.view"],
    },
    {
      id: "tax-invoice-reconciliation",
      title: "Đối soát hóa đơn BKAV",
      description: "Đặt lịch đối soát cho bản update tax cũ",
      icon: <FiRefreshCw />,
      category: "System",
      component: TaxInvoiceLegacyPage,
      requiredPermissions: ["admin.access"],
    },
  ];

  // Get features based on user permissions
  const currentFeatures = allFeatures.filter((feature) =>
    (feature.id === "tax-invoice-reconciliation" && userRole === "admin") ||
    feature.requiredPermissions.some((perm) => userPermissions.includes(perm))
  );

  const quickStats = [
    {
      label: "Total Products",
      value: "1,234",
      change: "+12%",
      trend: "up",
      icon: <FiPackage />,
    },
    {
      label: "Active Users",
      value: "567",
      change: "+8%",
      trend: "up",
      icon: <FiUsers />,
    },
    {
      label: "Today Orders",
      value: "89",
      change: "-3%",
      trend: "down",
      icon: <FiBarChart2 />,
    },
    {
      label: "Revenue",
      value: "₫2.5M",
      change: "+15%",
      trend: "up",
      icon: <FiDollarSign />,
    },
  ];

  const handleNavClick = (componentId) => {
    setActiveComponent(componentId);
  };

  const renderActiveComponent = () => {
    const activeFeature = currentFeatures.find(
      (feature) => feature.id === activeComponent
    );
    if (activeFeature && activeFeature.component) {
      const ComponentToRender = activeFeature.component;
      return (
        <div className="admin-main">
          <ComponentToRender />
        </div>
      );
    }

    // Default dashboard view
    return (
      <div className="admin-main">
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FiHome size={32} color="#495057" />
              <div>
                <h1>
                  {userRole === "admin"
                    ? "Admin Dashboard"
                    : "Bakery Dashboard"}
                </h1>
                <p>
                  Welcome back! Here's what's happening at your{" "}
                  {userRole === "admin" ? "bakery system" : "store"} today.
                </p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <div className="user-info">
              <span className="user-avatar">
                <FiUser />
              </span>
              <span className="user-name">
                {userRole === "admin" ? "Admin" : "Bakery"}
              </span>
            </div>
          </div>
        </header>

        {/* Quick Stats */}
        <div className="content-section">
          <div className="stats-grid">
            {quickStats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-header">
                  <div className="stat-icon">{stat.icon}</div>
                  <span className={`stat-trend ${stat.trend}`}>
                    {stat.trend === "up" ? (
                      <FiTrendingUp />
                    ) : (
                      <FiTrendingDown />
                    )}
                  </span>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
                <div className={`stat-change ${stat.trend}`}>
                  {stat.change} from last month
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Feature Cards */}
        <div className="content-section">
          <div className="section-header">
            <h2>{userRole === "admin" ? "Admin Tools" : "Bakery Tools"}</h2>
            <p>
              Manage your {userRole === "admin" ? "bakery system" : "store"}{" "}
              with these powerful tools
            </p>
          </div>

          <div className="features-grid">
            {currentFeatures.map((feature) => (
              <button
                key={feature.id}
                onClick={() => handleNavClick(feature.id)}
                className="feature-card"
              >
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                  <span className="feature-category">{feature.category}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Recent Activity */}
        <div className="content-section">
          <div className="section-header">
            <h2>Recent Activity</h2>
            <p>Latest system activities and updates</p>
          </div>

          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-icon">
                <FiCheckCircle />
              </div>
              <div className="activity-content">
                <h4>Product Updated</h4>
                <p>Bánh mì sandwich price updated to ₫25,000</p>
                <span className="activity-time">2 minutes ago</span>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-icon">
                <FiUsers />
              </div>
              <div className="activity-content">
                <h4>New Shift Added</h4>
                <p>Evening shift created for cashier position</p>
                <span className="activity-time">1 hour ago</span>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-icon">
                <FiRefreshCw />
              </div>
              <div className="activity-content">
                <h4>System Update</h4>
                <p>QR code payment method updated successfully</p>
                <span className="activity-time">3 hours ago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const chamCongParams = chamCongToken
    ? `?token=${chamCongToken}`
    : `?maPB=${maPB}`;

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">
              <FiHome />
            </span>
            <span className="logo-text">
              {userRole === "admin" ? "Bakery Admin" : "Bakery Store"}
            </span>
          </div>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            title={sidebarOpen ? "Close sidebar" : "Open sidebar"}
          >
            {sidebarOpen ? <FiChevronLeft /> : <FiChevronRight />}
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            <h3>Main</h3>
            <button
              onClick={() => handleNavClick("Home")}
              className={`nav-item ${activeComponent === "Home" ? "active" : ""
                }`}
            >
              <span className="nav-icon">
                <FiHome />
              </span>
              <span className="nav-text">Home</span>
            </button>
            {userPermissions.some((perm) =>
              ["system.access", "admin.access"].includes(perm)
            ) && (
                <>
                  {userPermissions.includes("cake.dashboard.view") && (
                    <button
                      onClick={() => handleNavClick("dashboard-banh-kem")}
                      className={`nav-item ${activeComponent === "dashboard-banh-kem" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiPieChart />
                      </span>
                      <span className="nav-text">Dashboard bánh kem</span>
                    </button>
                  )}
                  <button
                    onClick={() => handleNavClick("dashboard")}
                    className={`nav-item ${activeComponent === "dashboard" ? "active" : ""
                      }`}
                  >
                    <span className="nav-icon">
                      <FiHome />
                    </span>
                    <span className="nav-text">Export Excel</span>
                  </button>
                  <button
                    onClick={() =>
                    (window.location.href =
                      "https://doticom.vn:3000/dashboard?token=" +
                      localStorage.getItem("token"))
                    }
                    className={`nav-item ${activeComponent === "doanhso" ? "active" : ""
                      }`}
                  >
                    <span className="nav-icon">
                      <FiHome />
                    </span>
                    <span className="nav-text">Dashboard</span>
                  </button>
                </>
              )}
          </div>

          {/* Nhân sự */}
          {userPermissions.some((perm) =>
            ["hr.shift.manage", "user.manage", "hr.attendance.view", "hr.dashboard"].includes(perm)
          ) && (
              <div className="nav-section">
                <h3>Nhân sự</h3>
                <button
                  onClick={() =>
                  (window.location.href =
                    "https://chamcong.doticom.com.vn/" +
                    chamCongParams)
                  }
                  className={`nav-item ${activeComponent === "doanhso" ? "active" : ""
                    }`}
                >
                  <span className="nav-icon">
                    <FiClock />
                  </span>
                  <span className="nav-text">Chấm công</span>
                </button>
                <button
                  onClick={() =>
                  (window.location.href =
                    "http://admin-doticom.doticom.com.vn/admin/register" +
                    chamCongParams)
                  }
                  className={`nav-item ${activeComponent === "doanhso" ? "active" : ""
                    }`}
                >
                  <span className="nav-icon">
                    <FiClock />
                  </span>
                  <span className="nav-text">Đăng ký khuôn mặt</span>
                </button>
                {userPermissions.some((perm) =>
                  ["hr.shift.manage", "user.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("manage-shift")}
                      className={`nav-item ${activeComponent === "manage-shift" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiClock />
                      </span>
                      <span className="nav-text">Ca làm việc</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["hr.attendance.view", "user.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("gio-cham-cong")}
                      className={`nav-item ${activeComponent === "gio-cham-cong" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiClock />
                      </span>
                      <span className="nav-text">Giờ chấm công</span>
                    </button>
                  )}
                {userPermissions.includes("hr.dashboard") && (
                  <button
                    onClick={() =>
                    (window.location.href =
                      "https://admin-doticom.doticom.com.vn/admin/dashboard")
                    }
                    className={`nav-item ${activeComponent === "hr.dashboard" ? "active" : ""
                      }`}
                  >
                    <span className="nav-icon">
                      <FiHome />
                    </span>
                    <span className="nav-text">Dashboard Chấm công</span>
                  </button>
                )}
              </div>
            )}

          {/* Quản lý Sản phẩm */}
          {userPermissions.some((perm) =>
            ["product.price.manage", "product.manage", "product.create", "product.edit", "product.price.schedule"].includes(perm)
          ) && (
              <div className="nav-section">
                <h3>Quản lý Sản phẩm</h3>
                {userPermissions.some((perm) =>
                  ["product.price.manage", "product.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("manage-product")}
                      className={`nav-item ${activeComponent === "manage-product" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiPackage />
                      </span>
                      <span className="nav-text">Quản lý giá</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["product.price.schedule", "product.price.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("schedule-price-update")}
                      className={`nav-item ${activeComponent === "schedule-price-update" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiClock />
                      </span>
                      <span className="nav-text">Lịch cập nhật giá</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["product.manage", "product.create", "product.edit"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("manage-product-new")}
                      className={`nav-item ${activeComponent === "manage-product-new" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiPackage />
                      </span>
                      <span className="nav-text">Quản lý sản phẩm</span>
                    </button>
                  )}
              </div>
            )}

          {/* Quản lý Kho */}
          {userPermissions.some((perm) =>
            [
              "inventory.import.create", "inventory.manage", "inventory.transfer.create",
              "inventory.view", "inventory.audit.manage", "inventory.transfer.view",
              "inventory.transfer.approve", "report.sales.view", "report.view",
              "report.inventory.view"
            ].includes(perm)
          ) && (
              <div className="nav-section">
                <h3>Quản lý Kho</h3>
                {userPermissions.some((perm) =>
                  ["report.sales.view", "report.view"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("ds-trung-thu")}
                      className={`nav-item ${activeComponent === "ds-trung-thu" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiBarChart2 />
                      </span>
                      <span className="nav-text">Doanh số trung thu</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.import.create", "inventory.manage"].includes(perm)
                ) && (

                    <button
                      onClick={() => handleNavClick("nhap-hang-admin")}
                      className={`nav-item ${activeComponent === "nhap-hang-admin" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiPlus />
                      </span>
                      <span className="nav-text">Tạo phiếu nhập</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.transfer.create", "inventory.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("dieu-chuyen")}
                      className={`nav-item ${activeComponent === "dieu-chuyen" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiTruck />
                      </span>
                      <span className="nav-text">Điều chuyển kho</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.view", "inventory.manage"].includes(perm)
                ) && (
                    <>
                    {/*
                    <button
                      onClick={() => handleNavClick("manage-inventory")}
                      className={`nav-item ${activeComponent === "manage-inventory" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiBox />
                      </span>
                      <span className="nav-text">Quản lý tồn kho</span>
                    </button>
                    */}
                    <button
                      onClick={() => handleNavClick("pos-inventory")}
                      className={`nav-item ${activeComponent === "pos-inventory" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiActivity />
                      </span>
                      <span className="nav-text">Kho POS realtime</span>
                    </button>
                    </>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.audit.manage", "inventory.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("kiem-ke")}
                      className={`nav-item ${activeComponent === "kiem-ke" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiClipboard />
                      </span>
                      <span className="nav-text">Kiểm kê</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.transfer.view", "inventory.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("list-dieu-chuyen")}
                      className={`nav-item ${activeComponent === "list-dieu-chuyen" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiClipboard />
                      </span>
                      <span className="nav-text">Danh sách điều chuyển</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["inventory.transfer.approve", "inventory.manage"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("confirm-dieu-chuyen")}
                      className={`nav-item ${activeComponent === "confirm-dieu-chuyen" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiCheckCircle />
                      </span>
                      <span className="nav-text">Xác nhận điều chuyển</span>
                    </button>
                  )}
              </div>
            )}

          {/* Sản xuất */}
          {userPermissions.some((perm) =>
            ["production.materials.manage", "production.quota.manage", "admin.access"].includes(perm)
          ) && (
              <div className="nav-section">
                <h3>Sản xuất</h3>
                {userPermissions.some((perm) =>
                  ["production.materials.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("dinh-muc-dinh-luong")}
                      className={`nav-item ${activeComponent === "dinh-muc-dinh-luong" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FaBoxes />
                      </span>
                      <span className="nav-text">Nguyên liệu</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["production.quota.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("quan-ly-dinh-muc")}
                      className={`nav-item ${activeComponent === "quan-ly-dinh-muc" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FaWeight />
                      </span>
                      <span className="nav-text">Định mức</span>
                    </button>
                  )}
              </div>
            )}

          {userRole === "admin" && (
            <div className="nav-section">
              <h3>Hóa đơn thuế</h3>
              <button
                onClick={() => handleNavClick("tax-invoice-reconciliation")}
                className={`nav-item ${activeComponent === "tax-invoice-reconciliation" ? "active" : ""}`}
              >
                <span className="nav-icon"><FiRefreshCw /></span>
                <span className="nav-text">Đối soát BKAV</span>
              </button>
            </div>
          )}
          {/* Thanh toán & Cài đặt */}
          {userPermissions.some((perm) =>
            [
              "system.network.manage", "payment.qr.manage", "payment.rounding.manage",
              "admin.access", "store.info.manage"
            ].includes(perm)
          ) && (
              <div className="nav-section">
                <h3>Thanh toán & Cài đặt</h3>
                {userPermissions.some((perm) =>
                  ["system.network.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("update-ip")}
                      className={`nav-item ${activeComponent === "update-ip" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiGlobe />
                      </span>
                      <span className="nav-text">Network</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["payment.qr.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("update-qr-code")}
                      className={`nav-item ${activeComponent === "update-qr-code" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiCreditCard />
                      </span>
                      <span className="nav-text">Payment</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["payment.rounding.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("update-rounding")}
                      className={`nav-item ${activeComponent === "update-rounding" ? "active" : ""
                        }`}
                    >
                      <span className="nav-icon">
                        <FiDollarSign />
                      </span>
                      <span className="nav-text">Rounding</span>
                    </button>
                  )}
                {userPermissions.some((perm) =>
                  ["store.info.manage", "admin.access"].includes(perm)
                ) && (
                    <button
                      onClick={() => handleNavClick("store-info")}
                      className={`nav-item ${activeComponent === "store-info" ? "active" : ""}`}
                    >
                      <span className="nav-icon">
                        <FiShoppingBag />
                      </span>
                      <span className="nav-text">Thông tin cửa hàng</span>
                    </button>
                  )}
              </div>
            )}
          {userPermissions.some((perm) =>
            ["bill.view", "bill.manage", "sales.view"].includes(perm)
          ) && (
            <div className="nav-section">
              <h3>Quản lý Bán hàng</h3>
              <button
                onClick={() => handleNavClick("manage-bill")}
                className={`nav-item ${activeComponent === "manage-bill" ? "active" : ""
                  }`}
              >
                <span className="nav-icon">
                  <FiClipboard />
                </span>
                <span className="nav-text">Quản lý hóa đơn</span>
              </button>
            </div>
          )}

          {userPermissions.some(perm => ["admin.access", "permission.manage"].includes(perm)) && (
            <div className="nav-section"><h3>Khách hàng</h3>
              <button className={`nav-item ${activeComponent === "customer-management" ? "active" : ""}`} onClick={() => handleNavClick("customer-management")}><span className="nav-icon"><FiUsers /></span><span className="nav-text">Quản trị khách hàng</span></button>
              {[["voucher-management", "Phát hành Voucher"], ["customer-vouchers-manage", "Kho Voucher khách hàng"], ["promotion-management", "Ưu đãi cửa hàng"], ["customer-lookup-links", "Tạo link tra cứu Zalo"]].map(([feature, label]) => <button key={feature} className={`nav-item ${activeComponent === feature ? "active" : ""}`} onClick={() => handleNavClick(feature)}><span className="nav-icon"><FiUsers /></span><span className="nav-text">{label}</span></button>)}
            </div>
          )}

          {/* Phân quyền */}
          {userPermissions.includes("permission.manage") && (
            <div className="nav-section">
              <h3>Phân quyền</h3>
              <button
                onClick={() => handleNavClick("quan-ly-quyen")}
                className={`nav-item ${activeComponent === "quan-ly-quyen" ? "active" : ""
                  }`}
              >
                <span className="nav-icon">
                  <FiUser />
                </span>
                <span className="nav-text">Quản lý quyền</span>
              </button>
            </div>
          )}
        </nav>
      </div>

      {/* Main Content */}
      {renderActiveComponent()}
    </div>
  );
};

export default Admin;
